import { cloneDeep } from 'lodash';
import { sectorService } from './sector.service';
import { ganttService } from './gantt.service';
import {
  refreshCalendarsRewrite,
  defaultData
} from '../views/ganttContainer/gantt/gantt.helper';
import {
  convertActivityRelationToLink,
  convertActivitiesBatch
} from '../utils/activityParsingUtils';

/**
 * Procesa actividades y relaciones para el formato del gantt
 * @param {Object} sectorResActivity - Respuesta con actividades
 * @param {Object} sectorResActivityRelation - Respuesta con relaciones
 * @param {Array} calendars - Array de calendarios disponibles
 * @returns {Object} Objeto con data y links procesados
 */
const processActivitiesAndLinks = (
  sectorResActivity,
  sectorResActivityRelation,
  calendars,
  hasGantt
) => {
  let isANewProject = false;
  let data = [];
  let links = [];

  if (!sectorResActivity.sector?.length) {
    if (hasGantt) {
      const calendarId = calendars.length ? calendars[0].id : null;
      const tasks = cloneDeep(defaultData).data.map((item) => {
        item.calendarId = calendarId;
        item.calendar_id = calendarId;
        item.non_parsed_original_start_date = item.start_date;
        item.non_parsed_original_duration = item.duration;
        item.duration_milestone_bugged = item.duration;
        return item;
      });
      isANewProject = true;
      data = tasks;
      links = cloneDeep(defaultData).links;
    } else {
      data = [];
      links = [];
    }
  } else {
    data = convertActivitiesBatch(sectorResActivity.sector);
    links = sectorResActivityRelation.sector.map((activityrelation) =>
      convertActivityRelationToLink(activityrelation)
    );
  }

  if (data.length > 0) {
    window.backup_data_saving_use = data.map((ac) => ({
      ...ac,
      end_date: new Date(ac.non_parsed_original_end_date),
      responsables: [...(ac?.responsables || [])],
      tags: [...(ac?.tags || [])]
    }));
  }

  return { data, links, isANewProject };
};

/**
 * Servicio para cargar y procesar datos de actividades del sector
 */
export const sectorActivitiesService = {
  /**
   * Carga todas las actividades y datos relacionados del sector
   * @param {number|string} sectorId - ID del sector
   * @returns {Promise<Object>} Datos procesados del sector
   */
  async loadSectorData(sectorId) {
    try {
      const [
        sectorResActivity,
        sectorResActivityRelation,
        calendarsResult,
        ganttRes
      ] = await Promise.all([
        sectorService.showActivity(sectorId),
        sectorService.showActivityRelation(sectorId),
        refreshCalendarsRewrite(sectorId),
        ganttService.showBySector(sectorId)
      ]);

      // Extraer los datos de calendarios
      const { sectorRes, calendarsFusionated } = calendarsResult;
      const { calendars } = sectorRes.sector;

      const hasGantt = ganttRes && ganttRes.gantt && ganttRes.gantt.id;

      // Procesar actividades y links
      const { data, links, isANewProject } = processActivitiesAndLinks(
        sectorResActivity,
        sectorResActivityRelation,
        calendars,
        hasGantt
      );

      return {
        activities: data,
        links,
        calendars: calendarsFusionated,
        sector: sectorRes.sector,
        isANewProject,
        hasGantt,
        scheduleImpactRequestItems:
          sectorResActivity?.scheduleImpactRequests || []
      };
    } catch (error) {
      throw new Error('Error loading sector data');
    }
  }
};
